import { render, staticRenderFns } from "./MyRSservice.vue?vue&type=template&id=39f3bde2&scoped=true"
import script from "./MyRSservice.vue?vue&type=script&lang=js"
export * from "./MyRSservice.vue?vue&type=script&lang=js"
import style0 from "./MyRSservice.vue?vue&type=style&index=0&id=39f3bde2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f3bde2",
  null
  
)

export default component.exports